import MealTypeSizePrices from '../MealTypeSizePrices/MealTypeSizePrices';

const AdditionalPortionsPrices = () => (
  <MealTypeSizePrices
    priceField="defaultCostForAdditionalMealType"
    descriptionKey="$*priceLists.additionalPortions.description"
  />
);

export default AdditionalPortionsPrices;
